module.exports = "https://r.nearpod.com/assets/media/image/extended_icon-35abb7e69e5cdd1cad48c13623282925.svg";